import { RouteItem } from '@eastcoal/router/types/route'

import { VARIABLE_PAGE_PATH } from './constants/path'

export const variableRoute: RouteItem = {
  title: '变量管理',
  path: VARIABLE_PAGE_PATH,
  Component: () => import('./index')
}
